import { addBrandPrefix } from '../brandPrefix';

export const GLOBAL_FILTERS_STORAGE_NAME = addBrandPrefix('global_filters_store');
